import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { auth } from "../FIREBASE/firebase";
import routeUrls from "../COMPONENTS/navbar/navLink";
import "../CSS/login.scss";
import { usePageBackground } from "../COMPONENTS/usePageBackground";

export const LoginView = () => {
  usePageBackground();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  // Return to wherever login was triggered from; default to Resor rather than
  // dumping the user on the "new trip" admin page.
  const from = new URLSearchParams(location.search).get("from") ?? routeUrls.BLOGG;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await auth.signInWithEmailAndPassword(email, password);
      history.replace(from);
    } catch {
      setError("Fel e-post eller lösenord.");
    }
    setLoading(false);
  };

  return (
    <div className="login">
      <div className="login__box">
        <h1 className="login__title">Logga in</h1>
        <form onSubmit={handleSubmit}>
          <input
            className="login__input"
            type="email"
            placeholder="E-post"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            className="login__input"
            type="password"
            placeholder="Lösenord"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="login__error">{error}</p>}
          <button className="login__submit" type="submit" disabled={loading}>
            {loading ? "Loggar in…" : "Logga in"}
          </button>
        </form>
      </div>
    </div>
  );
};
